// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'amfe-flexible'
import axios from 'axios'
import {
  Backtop,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  Carousel,
  CarouselItem,
  Row,
  Col,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Link,
  Input,
  Button,
  Tabs,
  TabPane,
  RadioGroup,
  RadioButton,
  Collapse,
  CollapseItem,
  Tooltip,
  Pagination,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Divider,
  Form,
  FormItem,
  Table,
  TableColumn
} from 'element-ui'
import Swiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import router from './router'
import customTable from '@/views/components/customTable.vue'; // 自定义表格渲染
import Utils from './utils/utils.js'
import modal from './utils/modal.js'
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 分页组件
import Pageaction from "@/components/Pagination"
// 导航菜单组件
import MenuNav from "@/components/menu"
// 空白组件
import EmptyBox from "@/components/empty"
// 自定义表格
import briefBox from "@/views/components/briefBox.vue"
// 回到顶部
import BacktopBox from "@/components/Backtop/index.vue"

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import "./assets/styles/index.css";
import "./assets/styles/common.css";
Vue.component('ImagePreview', ImagePreview)
Vue.component('customTable', customTable)
Vue.component('Pageaction', Pageaction)
Vue.component('MenuNav', MenuNav)
Vue.component('EmptyBox', EmptyBox)
Vue.component('briefBox', briefBox)
Vue.component('BacktopBox', BacktopBox)

// console.log(process.env.NODE_ENV)

Vue.prototype.$utils = Utils
Vue.config.productionTip = false
Vue.prototype.$axios = axios
// 模态框对象
Vue.prototype.$modal = modal
Vue.use(Swiper)
Vue.use(Backtop)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Image)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Link)
Vue.use(Input)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Divider)
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Table);
Vue.use(TableColumn);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js